import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/comics';

function FooterNewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      return;
    }
    try {
      const res = await fetch('https://readdy.ai/api/form/d9p0eiaftmtnfcfh0f90', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后再试');
    }
  };

  return (
    <div>
      <h4 className="text-sm font-bold mb-3">订阅更新</h4>
      <p className="text-xs text-white/70 mb-3">第一时间获取最新漫画更新通知</p>
      {status === 'success' ? (
        <p className="text-sm text-accent-600 font-medium">订阅成功！感谢关注~</p>
      ) : (
        <form onSubmit={handleSubmit} className="flex gap-2" data-readdy-form="">
          <input
            type="email"
            name="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入邮箱地址"
            className="flex-1 text-sm bg-white/10 border border-white/20 rounded-md px-3 py-2 focus:outline-none focus:border-white/40 transition-colors text-white placeholder:text-white/40"
          />
          <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-honeypot" />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="text-sm bg-white text-secondary-600 px-4 py-2 rounded-md hover:bg-white/90 transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer disabled:opacity-50"
          >
            {status === 'loading' ? '订阅中...' : '订阅'}
          </button>
        </form>
      )}
      {status === 'error' && <p className="text-xs text-red-300 mt-2">{errorMsg}</p>}
    </div>
  );
}

export default function Footer() {
  const footerLinks = {
    '浏览分类': categories.slice(0, 4).map((c) => ({ label: c.name, href: `/category/${c.slug}` })),
    '关于我们': [
      { label: '品牌故事', href: '/about' },
      { label: '用户口碑', href: '/about#reviews' },
      { label: '联系我们', href: '/about#contact' },
    ],
    '帮助中心': [
      { label: '常见问题', href: '/about#faq' },
      { label: '阅读指南', href: '/about#guide' },
      { label: '版权声明', href: '/about#copyright' },
    ],
  };

  return (
    <footer className="bg-secondary-500">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold mb-3 block whitespace-nowrap text-white">
              洞洞杂货铺
            </Link>
            <p className="text-sm text-white/70 leading-relaxed">
              洞洞杂货铺漫画全集免费阅读尽在土豪漫画网，完整章节在线解锁，无需付费即可畅享，随时随地追漫无忧。
            </p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-bold mb-3 text-white">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <FooterNewsletterForm />
        </div>
        <div className="border-t border-white/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} 洞洞杂货铺 - 土豪漫画网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/50 hover:text-white transition-colors duration-200" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-white/50 hover:text-white transition-colors duration-200" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-white/50 hover:text-white transition-colors duration-200" aria-label="B站" rel="nofollow">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}